import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { isSelected?: boolean; applicationIcon?: string }) => ({
    item: {
      cursor: 'pointer',
      '&:hover': {
        '#title': {
          color: token.colorPrimary,
          transition: 'color 0.3s'
        }
      }
    },
    space: {
      width: '100% !important',
      justifyContent: 'space-between !important'
    },
    applicationIcon: {
      backgroundColor: props?.applicationIcon
    },
    text: {
      color: props.isSelected ? token.colorPrimary : token.colorTextBase
    },
    icon: {
      alignContent: 'center',
      borderRadius: 6,
      color: token.colorWhite,
      width: 48,
      fontSize: 24,
      height: 48,
      svg: {
        width: '100%'
      }
    },
    gridWrapper: {
      padding: 16
    },
    gridItem: {
      minHeight: 160,
      border: props.isSelected
        ? `1px solid ${token.colorPrimary}`
        : `1px solid ${token.colorBorder}`,
      borderRadius: 6,
      height: '100%',
      textAlign: 'center',
      justifyContent: 'center'
    },
    fullWidth: {
      width: '100%'
    }
  })
)
